<template>
<div>
 <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
   </div>
  <div v-if="changed">
     <b-container class="col-lg-10 mt-5">
       <h3 class="text-info text-center pt-4 my-4">Customers</h3>
    <!-- User Interface controls -->
     <b-row>
      <b-col sm="4" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="5" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">Sort By</option>
            </b-form-select>
            <b-form-select :disabled="!sortBy" v-model="sortDesc" slot="append">
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
     
      <b-col sm="3" class="my-1">
        <b-form-group horizontal class="mb-0">
          <b-form-select v-model="perPage">
            <option disabled>per page</option>
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table show-empty
             stacked="sm"
             :items="items"
             :fields="fields"
              :hover="true"
              head-variant="dark"
             :current-page="currentPage"
             :per-page="perPage"
             :filter="filter"
             :empty-text="emptyText"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             @filtered="onFiltered"
             class="mt-4">
    
    <template slot="index" slot-scope="data">
      {{data.index + 1}}
    </template>
   
      <template slot="id" slot-scope="row">
           <div>{{row.value}}
           </div>
      </template>
      
    </b-table>
     <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    <!-- Info modal -->
    <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
     
  </b-container>
</div>
</div>
</template>

<script>
import db from '../../config/FirebaseInit'
import firebase from "firebase/app"
const items = []
export default {
  name:'customers',
  data () {
    return {
      emptyText:'Loading Records...',
      items: [],
      fields: [
        'index',
        { key: 'name', label: 'Name', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'regdate', label: 'Registered Date', sortable: true },
        //{ key: 'actions', label: 'Actions' }
      ],
        productId:'',
         currentPage: 1,
        perPage: 10,
        totalRows: items.length,
        pageOptions: [ 10, 25, 50 ],
        sortBy: null,
        sortDesc: false,
        filter: null,
        isLoggedIn: false,
        currentUser: false,
        modalInfo: { title: '', content: '' },
         loading:false,
         loading1:false,
         loading2:false,
        changed:true,
        shops:[]
       
    }
  },

   computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
     
    info (item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getId(item){
      console.log('getId fun invoked')
      this.productId = item.id
      console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
     backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
  },
  created () {
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    this.backToTop()
    this.loading1 = true
    this.changed = false
    if(this.$store.state.users.length != 0){
        this.items = this.$store.state.users
         this.loading1 = false
        this.changed = true
    }else{
    db.collection('users').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id' : doc.id,
          'name': doc.data().name,
          'email' :doc.data().email,
          'regdate': doc.data().regdate
        }
        this.items.push(data)
        this.$store.state.users = this.items
       
          
      })
      if(this.items.length == 0){
          this.emptyText = 'There are no records to show'
        }
         this.loading1 = false
        this.changed = true
    })
   }
  },
}
</script>

<style scoped>
@import url('~@/assets/admin/css/admin-loader.css');
</style>




// WEBPACK FOOTER //
// src/components/admin/Customers.vue